Oskari.bundle_manager.registerDynamic('file-layerlist', function() {return import(/* webpackChunkName: "chunk_file-layerlist" */ 'oskari-loader!/opt/oskari/bundles/file-layerlist/bundle.js');});
